import { BACKTEST } from "../../data/Backtest.js"
import { formatCurrency } from "../../system/util.js"

export default function StrategyBacktestParameters({ backtest, statusMsg }) {

    const inputs = backtest.inputs

    let executionModeTxt = '-'
    if (inputs.executionMode == -1) {
        executionModeTxt = 'Random Delay'
    } else if (inputs.executionMode !== undefined) {
        executionModeTxt = inputs.executionMode + 'ms'
    }

    let modellingTxt = '-'
    if (inputs.model !== undefined) {
        modellingTxt = BACKTEST.MODEL.find(item => item.value == inputs.model)?.description || '-'
    }
    const rowCls = "flex items-center justify-between border-b border-border last:border-b-0 text-body text-foreground"
    const labelCls = "px-3 py-2 flex-1"
    const valueCls = "px-3 py-2 flex-1 border-l border-border"

    let statusEl
    if (statusMsg === "Error") {
        statusEl = <span className="text-danger">{statusMsg}</span>
    } else if (statusMsg === "Completed") {
        statusEl = <span className="text-success">{statusMsg}</span>
    } else if (statusMsg === "Processing") {
        statusEl = <span className="text-warning">{statusMsg}</span>
    } else {
        statusEl = <span>{statusMsg}</span>
    }

    return (
        <div className="rounded-md h-fit min-w-[300px] border border-border bg-popover text-popover-foreground shadow-popover overflow-hidden">
            <div className={rowCls}><span className={labelCls}>Symbol:</span><span className={valueCls}>{inputs.symbol}</span></div>
            <div className={rowCls}><span className={labelCls}>Timeframe:</span><span className={valueCls}>{inputs.period}</span></div>
            <div className={rowCls}><span className={labelCls}>Period:</span><span className={valueCls}>{inputs.dateStart} - {inputs.dateEnd}</span></div>
            <div className={rowCls}><span className={labelCls}>Delay:</span><span className={valueCls}>{executionModeTxt}</span></div>
            <div className={rowCls}><span className={labelCls}>Modelling:</span><span className={valueCls}>{modellingTxt}</span></div>
            <div className={rowCls}><span className={labelCls}>Deposit:</span><span className={valueCls}>{formatCurrency(inputs.depositAmount, inputs.depositCurrency)} {inputs.depositCurrency}</span></div>
            <div className={rowCls}><span className={labelCls}>Created:</span><span className={valueCls}>{backtest.created}</span></div>
            {backtest.description && (
                <div className={rowCls}><span className={labelCls}>Description:</span><span className={valueCls}>{backtest.description}</span></div>
            )}
            <div className={rowCls}><span className={labelCls}>Status:</span><span className={valueCls}>{statusEl}</span></div>
        </div>
    )
}
